(function () {
  'use strict';

  const drawer   = document.getElementById('ae-size-drawer');
  if (!drawer) return;

  const overlay   = document.getElementById('ae-size-drawer-overlay');
  const closeBtn  = document.getElementById('ae-size-drawer-close');
  const pillsWrap = document.getElementById('ae-size-drawer-pills');
  const ctaBtn    = document.getElementById('ae-size-drawer-cta');
  const titleEl   = document.getElementById('ae-size-drawer-title');
  const mediaEl   = document.getElementById('ae-size-drawer-media');
  const imgEl     = document.getElementById('ae-size-drawer-img');
  const strings   = window.aeSizeDrawerStrings || {};

  let selectedVariantId  = null;
  let currentProductData = null;

  // ── Data helpers ─────────────────────────────────────────────

  function getProductData(productId) {
    const el = document.querySelector(`script.ae-size-data[data-product-id="${productId}"]`);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function findSizeIndex(options) {
    const idx = options.findIndex(function (o) { return o.toLowerCase() === 'size'; });
    return idx >= 0 ? idx : 0;
  }

  function getSizeLabel(variant, sizeIndex) {
    return [variant.o0, variant.o1, variant.o2][sizeIndex] || variant.o0;
  }

  function dedupeBySize(variants, sizeIndex) {
    var seen = new Set();
    return variants.filter(function (v) {
      var label = getSizeLabel(v, sizeIndex);
      if (seen.has(label)) return false;
      seen.add(label);
      return true;
    });
  }

  // ── CTA state ─────────────────────────────────────────────────

  function setCta(state) {
    ctaBtn.dataset.state = state;
    if (state === 'select') {
      ctaBtn.textContent = strings.selectSize || 'Select a size';
      ctaBtn.disabled = true;
    } else if (state === 'add') {
      ctaBtn.textContent = strings.addToCart || 'Add to bag';
      ctaBtn.disabled = false;
    } else if (state === 'sold-out') {
      ctaBtn.textContent = strings.soldOut || 'Sold out';
      ctaBtn.disabled = true;
    } else if (state === 'loading') {
      ctaBtn.textContent = '…';
      ctaBtn.disabled = true;
    }
  }

  // ── Open / close ─────────────────────────────────────────────

  function open(productId) {
    var data = getProductData(productId);
    if (!data) return;

    selectedVariantId  = null;
    currentProductData = data;

    if (titleEl) {
      titleEl.textContent = data.title;
      titleEl.hidden = false;
    }

    if (imgEl && mediaEl) {
      if (data.image) {
        imgEl.src = data.image;
        imgEl.alt = data.title || '';
        mediaEl.hidden = false;
      } else {
        mediaEl.hidden = true;
      }
    }

    var sizeIndex = findSizeIndex(data.options || []);
    var sizeVariants = dedupeBySize(data.variants || [], sizeIndex);

    pillsWrap.innerHTML = '';
    sizeVariants.forEach(function (variant) {
      var label = getSizeLabel(variant, sizeIndex);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ae-size-drawer__pill' + (variant.available ? '' : ' ae-size-drawer__pill--oos');
      btn.textContent = label;
      btn.disabled = !variant.available;
      btn.dataset.variantId = variant.id;

      btn.addEventListener('click', function () {
        pillsWrap.querySelectorAll('.ae-size-drawer__pill').forEach(function (p) {
          p.classList.remove('ae-size-drawer__pill--selected');
        });
        btn.classList.add('ae-size-drawer__pill--selected');
        selectedVariantId = variant.id;
        setCta(variant.available ? 'add' : 'sold-out');
      });

      pillsWrap.appendChild(btn);
    });

    setCta('select');
    drawer.showModal();
    if (overlay) overlay.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    drawer.close();
    if (overlay) overlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
    selectedVariantId = null;
  }

  // ── Add to cart ───────────────────────────────────────────────

  ctaBtn.addEventListener('click', function () {
    if (!selectedVariantId || ctaBtn.disabled) return;

    setCta('loading');

    var cartAddUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url)
      ? window.Theme.routes.cart_add_url
      : '/cart/add.js';

    var properties = {};
    if (currentProductData) {
      var variantData = (currentProductData.variants || []).find(function (v) {
        return v.id === Number(selectedVariantId);
      });
      if (currentProductData.pim_product_id != null) {
        properties['_pim_product_id'] = String(currentProductData.pim_product_id);
      }
      if (variantData) {
        if (variantData.hscode)    properties['_hscode']              = String(variantData.hscode);
        if (variantData.coo)       properties['_country_of_origin']   = String(variantData.coo);
        if (variantData.gtin)      properties['_gtin']                = String(variantData.gtin);
        if (variantData.list_price != null) properties['_product_list_price'] = String(variantData.list_price);
        if (variantData.discount   != null) properties['_product_discount']   = String(variantData.discount);
        var marketRates =
          variantData.rates && typeof variantData.rates === 'object' && currentProductData.market
            ? variantData.rates[currentProductData.market]
            : null;
        if (marketRates != null) properties['_localised_rates'] = JSON.stringify(marketRates);
      }
    }

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: Number(selectedVariantId), quantity: 1, properties: properties }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed');
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: { didError: false } },
          })
        );
        if (window.miniCartDrawer && typeof window.miniCartDrawer.updateCartCount === 'function') {
          window.miniCartDrawer.updateCartCount();
        }
        close();
      })
      .catch(function () {
        setCta('add');
      });
  });

  // ── Close handlers ────────────────────────────────────────────

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  drawer.addEventListener('cancel', function (e) {
    e.preventDefault();
    close();
  });

  // ── Open drawer on trigger click ──────────────────────────────
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ae-drawer-trigger]');
    if (!trigger) return;
    open(trigger.dataset.productId);
  });
})();
